import React from "react";
import { Switch, Route } from "react-router-dom";
import { auth } from "routes/paths";
import Login from "./Login";
import ResetPass from "./ResetPass";
import ResetPasswordSuccess from "./ResetPasswordSuccess";
import SetPass from "./SetPass";
import SetPasswordSuccess from "./SetPasswordSuccess";

export default () => (
  <Switch>
    <Route exact path={auth.login} component={Login} />
    <Route exact path={auth.resetPassword} component={ResetPass} />
    <Route
      exact
      path={auth.resetPassSuccess}
      component={ResetPasswordSuccess}
    />
    <Route exact path={auth.setPassword} component={SetPass} />
    <Route exact path={auth.setPassSuccess} component={SetPasswordSuccess} />
  </Switch>
);



// WEBPACK FOOTER //
// ./src/components/pages/Auth/index.js